import { ObservationPhotoDisplay } from "./components/ObservationPhotoDisplay";

export default ObservationPhotoDisplay